import React from 'react';
import { getDeviationType } from '../_helpers';
import { DeviationTypes } from '../../types/deviation';
import ImageDumbView from './Image';
import UnknownDumbView from './Unknown';
import ErrorBoundary from '../../ErrorBoundary';
import MiniTextDumbView from './MiniText';
import LiteratureDumbView from './Literature';
import JournalDumbView from './Journal';
import { useDumboCommon } from './useDumbo';
import StatusDumbView from './Status';
// This is a variant on the normal dumbo, but just for the editor, this removes
// polls etc which cause circular deps...
const MinimalDeviationDumbView = (props)=>{
    const DumboReturn = useDumboCommon(props);
    if (DumboReturn) {
        return DumboReturn;
    }
    let DumbView;
    switch(getDeviationType(props.deviation)){
        // these types all have guaranteed thumb image
        case DeviationTypes.IMAGE:
        case DeviationTypes.PDF:
        case DeviationTypes.FILM:
            DumbView = ImageDumbView;
            break;
        case DeviationTypes.JOURNAL:
            DumbView = JournalDumbView;
            break;
        case DeviationTypes.LITERATURE:
            DumbView = LiteratureDumbView;
            break;
        case DeviationTypes.STATUS:
            DumbView = StatusDumbView;
            break;
        case DeviationTypes.COMMISSION:
            DumbView = MiniTextDumbView;
            break;
        default:
            DumbView = UnknownDumbView;
    }
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "EditorDumbo",
        style: {
            width: props.width,
            height: props.height
        }
    }, /*#__PURE__*/ React.createElement(DumbView, props));
};
MinimalDeviationDumbView.displayName = 'MinimalDeviationDumbView';
export default MinimalDeviationDumbView;
